import { AssetMimeTypes, Related, ResourceBase } from '../../resource-types';
import { RawModel } from '../schema';

export interface MetadataForm extends ResourceBase {
  category: string;
  category_name: string;
  display_name: string;
  fields: MetadataFormField[];
  created_at: string;
  deleted_at: string;
  error: boolean;
}
export interface MetadataFormField {
  id: string;
  key?: string; // not present use display_name
  json_schema: string;
  display_name: string;
  value_type:
    | 'string'
    | 'number'
    | 'email'
    | 'date'
    | 'select'
    | 'multiselect'
    | 'waterfall_select'
    | 'textarea'
    | 'resource_picker'
    | 'checkbox'
    | 'expires_at'
    | 'asset';
  required?: boolean;
  sort_order?: number;
  /** Field display name for exports feature */
  system_name?: string;
  read_only?: boolean;
  uses_suggestions?: boolean;
}
export interface MetadataCategory extends ResourceBase {
  type: 'metadata-category';
  for_mime_type: AssetMimeTypes;
  asset_type_id: number;
  category: string;
  category_name: string;
  display_name: string;
  metadata_fields: MetadataFormField[];
  created_at: string;
  deleted_at: string;
  error: boolean;
  read_only: boolean;
  sort_order?: number;
  relationships: {
    duplicate_of: Related<'metadata-category'>;
  };
}

export const metadataCategory: RawModel = {
  type: 'metadata-category',
  plural: 'metadata-categories',
  JSONApi: true,
  useWorker: true,
  attributes: {
    id: 'UUID',
    display_name: 'string',
    fields: 'array'
  },
  relationships: {
    'metadata-category_for': {
      type: ['asset', 'project'],
      binding: ['many', 'many'],
      reverse: 'metadata-categories',
      required: false
    }
  }
};
